<template>
  <div class="sleep-chart-container">
    <span class="title">Sleep Analysis</span>
    <div ref="sleepChartContainer" class="sleep-chart-div">
      <div class="sleep-chart-area">
        <div v-for="(bar, index) in hypnogramData" :key="index">
          <el-popover v-if="bar.segment != ''" effect="light" trigger="hover" placement="top" width="auto">
            <template #default>                            
              <div class="container">
                <strong>Stage:</strong> {{ bar.segment }} <br>
                <strong>Time:</strong> {{ bar.time }}
              </div>
            </template>
            <template #reference>
              <div :class="['bar', bar.stage]" :style="{ left: bar.left, width: bar.width }"> </div>
            </template>
          </el-popover>
      </div>
      </div>
    </div>
    <div class="time-label">
      <div>{{ bedTime }}</div>
      <div>{{ wakeTime }}</div>
    </div>
  </div>
  <div class="d-flex justify-content-evenly">
    <div class="item">
      <span class="color-box awake-box"></span> Awake
    </div>
    <div class="item">
      <span class="color-box light-sleep-box"></span> Light Sleep
    </div>
    <div class="item">
      <span class="color-box rem-sleep-box"></span> REM Sleep
    </div>
    <div class="item">
      <span class="color-box deep-sleep-box"></span> Deep Sleep
    </div>
  </div>
</template>

<script>
import DateUtils from "@/helpers/dateUtils";

export default {
  name: "SleepHypnoGram",
  props: {
    sleepData: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      sleepStages: ["", "light-sleep", "rem-sleep", "deep-sleep", "awake"],
      hypnogramData: [],
      bedTime: '',
      wakeTime: '',
    };
  },
  mounted() {
    this.prepareData();
  },
  methods: {
    prepareData() {
      const totalBars = this.sleepData.status.length;
      const chartWidth = this.$refs.sleepChartContainer.clientWidth;
      const barWidth = chartWidth / totalBars;
      const awakeBar = barWidth / 2;

      let tempData = [];
      this.bedTime = this.formatUnixTimeStamp(this.sleepData.status_start_time);
      this.wakeTime = this.formatUnixTimeStamp(this.sleepData.status_end_time);
      for (let i = 0; i < this.sleepData.status.length; i++) {
        let sleepPointTime = DateUtils.formatUnixTimeStampAddMinutes(this.sleepData.status_start_time, i + 1).toUpperCase()
        let status = parseInt(this.sleepData.status.charAt(i));
        let sleepStage = this.sleepStages[status];
        let sleepDataObj = {
          stage: sleepStage,
          status: status,
          duration: 1,
          time: sleepPointTime,
          segment: this.getSleepStageByNumber(status),
          left: `${(i / totalBars) * 100}%`,
          width: status == 4 ? `${awakeBar}px` : `${barWidth}px`,
        };
        tempData.push(sleepDataObj);
      }

      this.hypnogramData = tempData;
    },
    getSleepStageByNumber(sleepNumber) {
      if (sleepNumber == 1) {
        return 'Light'
      }

      if (sleepNumber == 2) {
        return 'Rem'
      }

      if (sleepNumber == 3) {
        return 'Deep'
      }

      if (sleepNumber == 4) {
        return 'Awake'
      }

      return ''
    },
    formatUnixTimeStamp(unixTime) {
      return DateUtils.formatUnixTimeStamp(unixTime).toUpperCase();
    },
  },
  computed: {
  }
};
</script>

<style>
.title {
  font-size: 1rem;
  font-weight: bold;
}
.sleep-chart-container {
  max-width: 100%;
  margin: auto;
}

.sleep-chart-div {
  border-right-style: dotted;
  border-color: #6c757d;
  border-left-style: dotted;
  width: 100%;
  height: 100%;
  height: 15rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.sleep-chart-area {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #1a1a1a;
  overflow: hidden;
}

.bar {
  position: absolute;
  cursor: pointer;
  height: 12rem;
}

.light-sleep {
  background-color: #cfe8e8;
  height: 4rem;
  margin-bottom: 8rem;
  border-right: 0.25px solid black;
}

.deep-sleep {
  background-color: #073E47;
  height: 4rem;
  margin-top: 8rem;
  border-right: 0.25px solid black;
}

.rem-sleep {
  background-color: #6cc7c1;
  height: 4rem;
  margin-bottom: 4rem;
  margin-top: 4rem;
  border-right: 0.25px solid black;
}

.awake {
  background-color: #ffd700;
  height: 12rem;
}

.time-label {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-top: 5px;
  opacity: 0.7;
  max-width: 1000px;
  margin: auto;
}

.legend {
  display: flex;
  gap: 1.5rem;
  padding-left: 5rem;
  padding-top: 1rem;
}

.item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  color: #d3d3d3;
}

.color-box {
  width: 1rem;
  height: 1rem;
  border-radius: 0.2rem;
}

.awake-box {
  background-color: #ffd700;
}

.light-sleep-box {
  background-color: #cfe8e8;
}

.rem-sleep-box {
  background-color: #6cc7c1;
}

.deep-sleep-box {
  background-color: #073E47;
}
</style>
